import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, ModuleFE_Dialog } from '@nu-art/thunderstorm-frontend/index';
import './Sandbox_Header.scss';
import { ICONS } from '@app/styles';
export class Sandbox_Header extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        return state;
    }
    render() {
        if (!this.props.label)
            return _jsx(_Fragment, {});
        return _jsxs(LL_H_C, { className: "sandbox-header", children: [this.props.label, _jsx(ICONS.x.component, { className: 'close-dialog-button', onClick: () => ModuleFE_Dialog.close() })] });
    }
}
//# sourceMappingURL=Sandbox_Header.js.map